import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const DataItemStyles = StyleSheet.create({
	container: {
		marginBottom: 10
	},
	containerSmall: {
		marginBottom: 6,
	},
	headerContainer: {
		flex: 1,
		flexDirection: 'row',
	},
	headerIconContainer: {
		paddingTop: 0.5
	},
	headerIcon: {
		fontSize: 12,
		color: colorList.BLACK.light,
		paddingRight: 3
	},
		headerIconRed: {
			color: colorList.RED.primary,
		},
		headerIconBlue: {
			color: colorList.BLUE.primary,
		},
		headerIconGreen: {
			color: colorList.GREEN.primary,
		},
	headerTextContainer: {
	
	},
	headerText: {
		fontSize: 11,
		fontWeight: '700',
		color: colorList.BLACK.light,
		marginBottom: 1,
		textTransform: 'uppercase'
	},
	headerTextRed:{
		color: colorList.RED.primary,
	},
	text: {
		fontSize: 14,
		color: colorList.TEXT.primary,
		fontWeight: '500',
		fontStyle: 'normal',
		textTransform: 'none',
		marginLeft: 10,
	},
		textRed: {
			color: colorList.RED.primary,
		},
		textBlue: {
			color: colorList.BLUE.primary
		},
		textGreen: {
			color: colorList.GREEN.primary
		},
		textGrey: {
			color: colorList.BLACK.light
		},
		textStrong: {
			fontWeight: '700'
		},
	
	itemContainer: {
		flex: 1,
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginLeft: 10,
		marginRight: 10
	}
});
